import React from 'react';
import Styles from './cover.module.css';
import cw from 'classnames';

const Cover = ({
  image,
  height,
  children,
  overlay,
  filter,
  mobileCollapse,
}) => {
  const getOverlayDirection = (overlayInput) => {
    switch (overlay) {
      case null:
        return null;
      case 'left':
        return Styles.Leftoverlay;
      case 'right':
        return Styles.Rightoverlay;
      case 'center':
        return Styles.Centeroverlay;
      default:
        return Styles.Leftoverlay;
    }
  };

  return (
    <div
      style={{ minHeight: `${height}px`, maxHeight: `${height + 100}px` }}
      className={`${Styles.Cover} ${mobileCollapse && Styles.Mobile}`}
    >
      {overlay && (
        <div
          className={cw(
            Styles.Overlay,
            getOverlayDirection(overlay),
            filter ? Styles.Filter : ''
          )}
        />
      )}
      <img src={image} alt='cover' />
      <div className={Styles.Content}>{children}</div>
    </div>
  );
};

export default Cover;
